import { useEffect, useRef, useState, useMemo } from 'react';
import Fab from '@mui/material/Fab';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IsInViewport from './IsInViewport';
import styles from './ScrollMore.module.css'; // Import css modules stylesheet as styles

export default function ScrollMore(ref) {
    const bottomOfContentRef = useRef(null);
    const isInViewport1 = IsInViewport(bottomOfContentRef);
    console.log(isInViewport1);

    function scrollToBottom() {
        bottomOfContentRef.current.scrollIntoView({ behavior: 'smooth' });
    }

    return (
           
        <div ref={bottomOfContentRef}>
            {!isInViewport1 &&
                <Fab size="small" onClick={() => scrollToBottom()} className='scroll-to-bottom' sx={{ fontSize: 40, backgroundColor: 'var(--sipzee-yellow-2)' }}
                    aria-label="more">
                    <ExpandMoreIcon className={[styles.arrows, styles.a2]} sx={{ fontSize: 40 }} />
                </Fab>
            }
        </div>
    );

}